<template>
  <div>
    <el-button type="primary" @click="addExtraForStu" icon="plus">关联特色课程</el-button>
    <Modal v-model="modalShow" width="760" footer-hide>
      <p slot="header" style="text-align:center;font-size:15px">
        <Icon type="ios-information-circle"></Icon>
        <span>关联特色课程</span>
      </p>
      <div>
        <el-form :inline="true" :model="formExtra" label-width="120px">
          <el-form-item label="特色课程名称:">
            <el-input v-model="formExtra.name" placeholder="输入特色课程名称"></el-input>
          </el-form-item>
          <el-form-item label="级别:">
            <el-input v-model="formExtra.level" placeholder="输入特色课程级别"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="search" @click="onQuery">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-table
          ref="multipleTable"
          :data="queryData"
          stripe
          border
          tooltip-effect="dark"
          style="width: 100%"
          class="elTable"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="50" 
      ></el-table-column>
          <el-table-column prop="id" label="特色课程ID" align="center" width="120">
            <template slot-scope="scope">
              <a
                href="javascript:;"
                @click="viewExtra(scope.row)"
                style="color:#1d90e6"
              >{{ scope.row.id }}</a>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="特色课程名称" align="center" min-width="200">
            <template slot-scope="scope">
              <a
                href="javascript:;"
                @click="viewExtra(scope.row)"
                style="color:#1d90e6"
              >{{ scope.row.name }}</a>
            </template>
          </el-table-column>
          <el-table-column prop="level" label="级别" align="center" width="90"></el-table-column>
          <el-table-column prop="count" label="数量" align="center" min-width="120"></el-table-column>
          <el-table-column prop="enabled" label="状态" align="center" min-width="100">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.enabled" type="success">已上架</el-tag>
              <el-tag v-else type="danger">已下架</el-tag>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="queryParams.page"
            :page-sizes="[20, 50, 100]"
            :page-size="queryParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal"
          ></el-pagination>
        </div>
      </div>
      <Divider />
      <el-button type="primary" @click="modalConfirm" style="margin-left:300px">确定</el-button>
      <el-button type="primary" @click="modalCancel">取消</el-button>
    </Modal>
  </div>
</template>

<script>
import { ApiMessage, formatDate } from "@/utils/util";
export default {
  name: "stuAddExtra",
  components: {},
  data() {
    return {
      modalShow: false,
      formExtra: {
        name: "",
        level: "",
      },
      pageTotal: 0,
      queryData: [],
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      multipleSelection: [],
      loading: true,
    };
  },
  props: {
    len: {
      type: Number,
      default: 1,
    }
  },
  created() {},
  watch: {},
  methods: {
    addExtraForStu() {
      if (this.len > 0) {
        this.modalShow = true;
        this.fetchExtraList();
      } else {
        alert("请先选择学生");
        return;
      }
    },
    fetchExtraList() {
      this.loading = true;
      let params = {
        appId: this.$API.APPID,
      };
      if (this.formExtra.name != "") {
        params.name = this.formExtra.name;
      }
      if (this.formExtra.level != "") {
        params.level = this.formExtra.level;
      }
      params.pageSize = this.queryParams.pageSize;
      params.page = this.queryParams.page;
      params.courseType = 0
      this.eduAxiosPostRequest("/edu/eduAdmin/course/extra_list", params).then(
        (res) => {
          if (res != null) {
            let m = JSON.parse(res);
            this.queryData = m.list;
            this.pageTotal = m.pager.total;
          }
          this.loading = false;
        }
      );
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.fetchExtraList();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.fetchExtraList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    modalConfirm() {
      this.$emit("extraResult", this.multipleSelection);
      this.modalShow = false;
    },
    modalCancel() {
      this.modalShow = false;
    },
    onQuery() {
      this.queryParams.page = 1;

      this.fetchExtraList();
    },
    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            console.log(response);
            if (response.data.rc == "0") {
              resolve(JSON.stringify(response.data.data));
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>

<style lang="less">
</style>


// WEBPACK FOOTER //
// stuAddExtra.vue?4790437a